<script lang="ts">
  import ItemLabelValueColumn from "../Card/ItemLabelValueColumn.svelte";

  export let label: string;
  export let value: string;
</script>

<div class="flex items-center gap-3 self-center w-full text-left">
  <ItemLabelValueColumn {label} {value} />
</div>
